import { Helmet } from "react-helmet";

import { PageTitle } from "@/common/CommonComponents";
import BidFilters from "@/bids/BidFilters";
import BidRow from "@/bids/BidRow";
import CustomTableContainer from "@/table//CustomTableContainer";

const headCells = [
    { id: "name", label: "Name", orderable: true },
    { id: "project_id", label: "Project", orderable: true },
    { id: "_client", label: "Client" },
    { id: "client_quoted", label: "Quoted", orderable: true, numeric: true },
    {
        id: "gross_profit_margin",
        label: "Margin",
        orderable: true,
        numeric: true,
    },
    { id: "status", label: "Status", orderable: true },
    { id: "_actions", label: "" },
];

export default function Bids() {
    return (
        <CustomTableContainer
            modelType="bid"
            defaultOrder="-updated_at"
            title="Bid Sheets"
            headCells={headCells}
            itemRowComponent={BidRow}
            filterComponents={BidFilters}
            enableExport={false}
        >
            <Helmet>
                <PageTitle title="Bid Sheets" />
            </Helmet>
        </CustomTableContainer>
    );
}
